import styled from '@emotion/styled';

export const ModalLayout = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ModalHeader = styled.div`
  padding: 16px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
`;

export const ModalHeaderRow = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
`;

export const ModalBody = styled.div`
  padding: 0;

  .ant-tabs-tab {
    padding: 8px 16px 8px 16px !important;
    margin-top: 8px !important;
  }

  .ant-tabs-tabpane {
    padding: 16px !important;
  }
`;
